var idResize; //for resize-timer
var windowsWidth = jQuery(window).outerWidth();
let movement = "";
let oldx = 0;
let oldy = -1;
var scroll_start = 0;
var startchange = jQuery(".entry-content")[0];
var startchangeOffsetTop = typeof (startchange) != 'undefined' ? startchange.offsetTop + 0 : 0;
let navbarToggler = jQuery(".navbar-toggler")[0];
/**
 * File navigation.js.
 *
 * Handles toggling the navigation menu for small screens and enables TAB key
 * navigation support for dropdown menus.
 */
function handleHasHiddenTextToggleClassClicked(caller = null)
{
  let actionContainers = jQuery(".action-click-container .action-container .action-one");
  let actionContainersLength = actionContainers.length;
  let i = 1;
  let changedClass = false;
  if (!actionContainersLength)
  {
    actionContainersLength = 0;
  }
  if (actionContainersLength > 0)
  {
    Object.keys(actionContainers).forEach(actionContainer =>
    {
      if (i > Number(actionContainersLength))
      {
        return;
      }
      // let hiddenTextContainer = jQuery(actionContainers[actionContainer]).closest('.has-hidden-text');
      if (jQuery(actionContainers[actionContainer]).hasClass('show'))
      {
        jQuery(actionContainers[actionContainer]).removeClass('show');
        if (caller == actionContainers[actionContainer])
        {
          changedClass = true;
        }
      }
      i++;
    });
  }
  return changedClass;
}
function zw_toggle_mega_menu(menuitem, closestA) {
  // jQuery('.main-header').addClass('zw-flow-none');
  console.debug('MENU TOGGLED!!!!')
  closestA = menuitem.closest(".menu-item-has-children")[0].firstChild;
  let closestAInnerText = closestA.innerHTML;
  let closestAHref = jQuery(closestA).attr("href");
  // console.log(closestAHref)
  let parentUL = jQuery(menuitem).parent().parent();
  let parentLI = jQuery(menuitem).parent();
  let nextLvlUl = jQuery(menuitem).siblings(".dropdown-menu");
  // nextLvlUl[0].children[0].innerHTML = closestAInnerText;
  // console.log("nextLvlUl[0].children[0].innerHTML", nextLvlUl[0].children[0].innerHTML)
  nextLvlUl[0].children[0].innerHTML =
    '<span class="back-icon" onclick="zw_toggle_mega_menu_back(jQuery(this))"></span><span class="back-button" ><a href="' +
    closestAHref +
    '">' +
    closestAInnerText +
    "</a></span>";
  jQuery(nextLvlUl).toggleClass("d-flex");
  jQuery(parentUL).toggleClass("invisible");
  jQuery(parentLI).toggleClass("menu-active");
  jQuery(nextLvlUl).toggleClass("visible");

  if (jQuery(menuitem).parent().parent().hasClass("dropdown-menu")) {
    jQuery(menuitem)
      .parent()
      .parent()
      .children(".backtext")
      .toggleClass("d-none");
  }
}

window.zw_toggle_mega_menu = zw_toggle_mega_menu;

function zw_toggle_mega_menu_back(menuitem) {
  // jQuery('.main-header').removeClass('zw-flow-none');
  console.debug('MENU TOGGLED BACK!!!!')
  menuitem = jQuery(menuitem).closest(".backtext");
  var parentUL = jQuery(menuitem).parent();
  // zw_main_menu_same_height(parentUL);
  jQuery(menuitem)
    .parents("ul")
    .find(".backtext")
    .each(function () {
      if (jQuery(this).hasClass("d-none")) {
        jQuery(this).removeClass("d-none");
      }
    });
  jQuery(parentUL).toggleClass("d-flex");
  // var parentULwithNullHeight = parentUL.parent().parent('ul.null-height');
  // jQuery(parentULwithNullHeight).toggleClass('null-height');
  var parentULwithNullHeight = parentUL.parent().parent("ul.invisible");
  jQuery(parentULwithNullHeight).toggleClass("invisible");
  jQuery(parentUL).toggleClass("visible");
  jQuery(parentUL).parent().toggleClass("menu-active");
}

window.zw_toggle_mega_menu_back = zw_toggle_mega_menu_back;

/**
 * Make Main Menu drop-down ul same height
 */

function zw_main_menu_same_height(startElemente) {
  var outerHeight = jQuery("#main-menu").outerHeight();
  var curHeight = jQuery(startElemente).outerHeight();

  if (curHeight > outerHeight) {
    jQuery("#main-menu").css("height", curHeight + "px");
    outerHeight = curHeight;
  }
  var padding = outerHeight - curHeight;
  var calcString =
    "calc(" +
    jQuery(startElemente).css("padding-bottom") +
    " + " +
    padding +
    "px)";

  jQuery(startElemente).css("padding-bottom", calcString);
  jQuery(startElemente).css({
    height: outerHeight + "px",
    width: "100%",
  });
}

window.zw_main_menu_same_height = zw_main_menu_same_height;

/* Scroll to anchor */
function pgshow(e)
{
    var elId = window.location.hash;
    if (elId.length > 1)
    {
        let el = document.getElementById(elId.substr(1));
        if (el) el.scrollIntoView(true);
    }
}
window.pgshow = pgshow;

// pageshow fires after load and on Back/Forward
window.addEventListener("pageshow", pgshow);

function stickyAnimation() {
  // setTimeout(() => { r.style.setProperty('--zw-opacity-sticky-btn', '1') }, 2000);
  var r = document.querySelector(":root");

  function animation() {
    // 10 sec then play animation // nach 2 play naimaton // 4 sec return no animation
    setTimeout(() => {
      r.style.setProperty("--zw-opacity-sticky-btn", "0");

      setTimeout(() => {
        r.style.setProperty("--zw-opacity-sticky-btn", "1");
        setTimeout(() => {
          animation();
        }, 2000);
      }, 2000);
    }, 4000);
  }
  animation();
}

// window.stickyAnimation = stickyAnimation;

/* Share popup function */

function zw_social_share(data) {
  window.open(
    data,
    "Share",
    "height=500,width=760,top=" +
      (jQuery(window).height() / 2 - 250) +
      ", left=" +
      (jQuery(window).width() / 2 - 380) +
      "resizable=0,toolbar=0,menubar=0,status=0,location=0,scrollbars=0"
  );
}
window.zw_social_share = zw_social_share;

function zw_show_rating_stars(trigger) {
  jQuery(trigger)
    .next(".rmp-rating-widget__icons-list")
    .removeClass("d-none")
    .addClass("d-flex");
  jQuery(trigger).addClass("d-none");
}
window.zw_show_rating_stars = zw_show_rating_stars;

function zw_hide_rating_after_rate(trigger) {
  console.log(trigger);
  jQuery(trigger.currentTarget)
    .closest(".js-rmp-rating-widget")
    .delay(2000)
    .queue(function () {
      jQuery(this).addClass("d-none").dequeue();
    });
}
window.zw_hide_rating_after_rate = zw_hide_rating_after_rate;

function zw_archive_filter_init()
{
  // Select the filters and elements for the archive filter functionality
  const filters = jQuery('.zw-archive .searchfield .zw-field');
  const elements = jQuery('.zw-archive .zw-filter-content .zw-filter-item');
  const errorMessage = jQuery('.zw-archive .errorFilterMessage');

  // Attach an event listener for change events on the filters
  jQuery(filters).on("change", function ()
  {
    let selectedValues = [];

    // Iterate through each filter to collect selected values
    jQuery(filters).each(function (index)
    {
      var selected = jQuery(this).find(":selected").val();
      if (selected != '') // If the selected value is not empty, push it to the selectedValues array
      {
        selectedValues.push(Number(selected));
      }
    });

    // console.debug('Selected Values: ', selectedValues); 

    let foundSome = false;
    let allPossibleTerms = [];

    // Iterate through each element and apply the filter logic
    jQuery(elements).each(function ()
    {
      let termIdArray = JSON.parse(jQuery(this).attr('data-zw-terms')); // Parse the term IDs
      var i;
      let noMatch = false;

      // console.debug("termIdArray", termIdArray) 

      // Logic to check if all selected values match the termIdArray
      let checker = (arr, target) => target.every(v => arr.includes(v));
      if (checker(termIdArray, selectedValues))
      {
        jQuery(this).removeClass('d-none');
        // jQuery(this).addClass('d-flex');
        noMatch = true;
        foundSome = true;
        allPossibleTerms.push(...termIdArray);
      }

      if (noMatch === false) // If no match, hide the element
      {
        // jQuery(this).removeClass('d-flex');
        jQuery(this).addClass('d-none');
      }
    });

    allPossibleTerms = [...new Set(allPossibleTerms)]; // Remove duplicates from allPossibleTerms
    // console.debug('allPossibleTerms', allPossibleTerms); 

    // Iterate through each filter to enable/disable options based on the terms
    jQuery(filters).each(function ()
    {
      // console.debug('select: ', this); // Debugging statement to show the filter select element
      const options = Array.from(this.options);
      let doContinue = true;

      // If only one value is selected, check if the entire selectbox should be enabled
      if (selectedValues.length === 1)
      {
        options.forEach((option) =>
        {
          if (selectedValues.includes(Number(option.value)))
          {
            doContinue = false;
          }
        });
      }

      // Enable or disable options based on matching terms
      if (doContinue)
      {
        options.forEach((option) =>
        {
          if (allPossibleTerms.includes(Number(option.value)) || option.value == "")
          {
            option.disabled = false;
          } else
          {
            option.disabled = true;
          }
        });
      } else // enable entire selectbox
      {
        options.forEach((option) =>
        {
          option.disabled = false;
        });
      }
    });

    // Show or hide the error message based on whether any elements were found
    if (foundSome)
    {
      jQuery(errorMessage).removeClass('d-block');
      jQuery(errorMessage).addClass('d-none');
    } else
    {
      jQuery(errorMessage).removeClass('d-none');
      jQuery(errorMessage).addClass('d-block');
    }
  });
}


function handle_archive_filter_zw_selects()
{
  // Select the filters and elements for the archive filter functionality
  const filters = jQuery('.zw-archive .searchfield .dropdown-menu');
  const elements = jQuery('.zw-archive .zw-filter-content .zw-filter-item');
  const errorMessage = jQuery('.zw-archive .errorFilterMessage');

  let selectedValues = [];
  // Iterate through each filter to collect selected values
  jQuery(filters).each(function (index)
  {
    var selected = this.dataset['selected'];
    if (selected != '') // If the selected value is not empty, push it to the selectedValues array
    {
      selectedValues.push(Number(selected));
    }
  });

  // console.debug('Selected Values: ', selectedValues); 

  let foundSome = false;
  let allPossibleTerms = [];

  // Iterate through each element and apply the filter logic
  jQuery(elements).each(function ()
  {
    let termIdArray = JSON.parse(jQuery(this).attr('data-zw-terms')); // Parse the term IDs
    var i;
    let noMatch = false;

    // console.debug("termIdArray", termIdArray) 

    // Logic to check if all selected values match the termIdArray
    let checker = (arr, target) => target.every(v => arr.includes(v));
    if (checker(termIdArray, selectedValues))
    {
      jQuery(this).removeClass('d-none');
      // jQuery(this).addClass('d-flex');
      noMatch = true;
      foundSome = true;
      allPossibleTerms.push(...termIdArray);
    }

    if (noMatch === false) // If no match, hide the element
    {
      // jQuery(this).removeClass('d-flex');
      jQuery(this).addClass('d-none');
    }
  });

  allPossibleTerms = [...new Set(allPossibleTerms)]; // Remove duplicates from allPossibleTerms
  // console.debug('allPossibleTerms', allPossibleTerms); 

  // Iterate through each filter to enable/disable options based on the terms
  jQuery(filters).each(function ()
  {
    // console.debug('select: ', this); // Debugging statement to show the filter select element
    const options = Array.from(this.childNodes);
    let doContinue = true;

    // If only one value is selected, check if the entire selectbox should be enabled
    if (selectedValues.length === 1)
    {
      options.forEach((option) =>
      {
        const value = jQuery(option).data('value');
        if (selectedValues.includes(Number(value)))
        {
          doContinue = false;
        }
      });
    }
    // console.debug('selectedValues', selectedValues);
    // console.debug('allPossibleTerms', allPossibleTerms);
    // Enable or disable options based on matching terms
    if (doContinue)
    {
      options.forEach((option) =>
      {
        const value = jQuery(option).data('value')
        if (allPossibleTerms.includes(Number(value)) || value == "")
        {
          // option.disabled = false;
          jQuery(option).removeClass('disabled');
        } else
        {
          // option.disabled = true;
          jQuery(option).addClass('disabled');
        }
      });
    } else // enable entire selectbox
    {
      options.forEach((option) =>
      {
        // option.disabled = false;
        jQuery(option).removeClass('disabled');
      });
    }
  });

  // Show or hide the error message based on whether any elements were found
  if (foundSome)
  {
    jQuery(errorMessage).removeClass('d-block');
    jQuery(errorMessage).addClass('d-none');
  } else
  {
    jQuery(errorMessage).removeClass('d-none');
    jQuery(errorMessage).addClass('d-block');
  }
}

function addClickListenerToCustomSelectOptions()
{
  jQuery('.zw-select .dropdown-menu li').click(function ()
  {
    this.closest('.zw-select').querySelector('.zw-field-custom').innerText = this.innerText;

    this.closest('.zw-select').querySelector('.dropdown-menu').dataset['selected'] = this.dataset['value'];
    handle_archive_filter_zw_selects();
  })
}

function addClickListenerToClearFilterButton()
{
  jQuery('.zw-reset-filter-button').click(function ()
  {

    const filters = jQuery('.zw-archive .searchfield .dropdown-menu');
    jQuery(filters).each(function (index)
    {
      this.closest('.zw-select').querySelector('.zw-field-custom').innerText = this.children[0].innerHTML;
      this.dataset['selected'] = '';
      handle_archive_filter_zw_selects();
    });
  })
}

function observeChangeInMobileNavClassList(){
  // Select the element you want to observe
  const targetElement = document.querySelector('#mainmenutoggler');

  // Create an observer instance
  const observer = new MutationObserver((mutationsList) =>
  {
    mutationsList.forEach((mutation) =>
    {
      if (mutation.type === 'attributes' && mutation.attributeName === 'class')
      {
        const hasShowClass = mutation.target.classList.contains('show');

        if (hasShowClass)
        {
          jQuery('body').addClass('zw-show-mobile');
          // Add any other actions when .show is added
          // zw_toggle_mega_menu();
        } else
        {
          jQuery('body').removeClass('zw-show-mobile');
          // Add any other actions when .show is removed
          // zw_toggle_mega_menu_back();
        }
      }
    });
  });

  // Configuration of the observer (listen to changes in attributes, specifically the class attribute)
  const config = {
    attributes: true, // Observe attribute changes
    attributeFilter: ['class'] // Only listen for class attribute changes
  };

  // Start observing the target element
  observer.observe(targetElement, config);

  // To stop observing at some point, you can use:
  // observer.disconnect();
}


jQuery(document).ready(function () {
  window.setTimeout(() => {
    //listen for class change in mobile nav
    observeChangeInMobileNavClassList();

    // Initialize essential variables outside of the scroll handlers to avoid repeated calculations.
    const windowsWidth = jQuery(window).width();
    const mainHeader = jQuery(".main-header");
    let scrollStart = 0;
    let startChangeOffsetTop = Math.max(
      0,
      parseInt(mainHeader.data("offset-top"), 10) || 0
    );

    // Function to toggle sticky class based on scroll position.
    function toggleStickyHeader() {
      let scrollStart = jQuery(window).scrollTop();
      if (scrollStart > startChangeOffsetTop) {
        mainHeader.addClass("sticky");
      } else {
        if (
          windowsWidth < 1250 &&
          !jQuery("#mainmenutoggler").hasClass("show")
        ) {
          mainHeader.removeClass("sticky");
        } else if (windowsWidth >= 1250) {
          mainHeader.removeClass("sticky");
        }
      }
    }
    window.toggleStickyHeader = toggleStickyHeader;

    // Call the function once initially and bind it to scroll events.
    toggleStickyHeader();
    jQuery(window).scroll(toggleStickyHeader);

    // Sticky header and action handling for different window widths.
    // stickyAnimation();
    // Handling social share toggler clicks.
    // jQuery('body').on('click', '.zw-social-share .zw-social-share-toggler', function (e)
    // {
    //     e.preventDefault();
    //     let $currentTarget = jQuery(e.currentTarget);
    //     let ariaStatus = $currentTarget.attr('aria-expanded') === 'false';
    //     $currentTarget.attr('aria-expanded', ariaStatus ? 'true' : 'false');
    //     $currentTarget.parents('.zw-social-share').find('.zw-share-dropdown-menu').toggleClass('show');
    // });

    // Rating widget click handling.
    jQuery(".js-rmp-rating-widget .js-rmp-rating-icon").click(function (e) {
      zw_hide_rating_after_rate(e);
    });

    // Mutation observer for navbar toggler changes.
    const observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        switch (mutation.type) {
          case "attributes":
            switch (mutation.attributeName) {
              case "aria-expanded":
                scroll_start = jQuery(this).scrollTop();
                if (startchangeOffsetTop < 0) {
                  startchangeOffsetTop = 0;
                }
                if (
                  mutation.target.attributes["aria-expanded"].value == "true"
                ) {
                  jQuery(".main-header").addClass("aria-class");
                } else if (scroll_start <= startchangeOffsetTop) {
                  jQuery(".main-header").removeClass("aria-class");
                }
                break;
            }
            break;
        }
      });
    });

    // Assuming navbarToggler is defined correctly elsewhere in your script.
    if (typeof (navbarToggler) != 'undefined')
    {
      observer.observe(navbarToggler, {
        attributes: true,
        subtree: true,
        childList: true,
        attributeFilter: ["aria-expanded"],
      });
    }


    // Hide navigation on item click.
    jQuery("#main-menu .dropdown-item, #main-menu .nav-link").on(
      "click",
      function () {
        jQuery(".navbar-collapse").collapse("hide");
      }
    );
  }, 0);

  //sticky iconc click handler 
  zw_archive_filter_init();
  //selectOptionsClickHandler
  addClickListenerToCustomSelectOptions();
  addClickListenerToClearFilterButton();
  jQuery(".action-click-container .action-container .action-one").click(function (e)
  {
    const changedClass = handleHasHiddenTextToggleClassClicked(this);
    if (!changedClass)
    {
      jQuery(this).toggleClass('show');
    }
  });
});

/**
 * On Resize
 */
jQuery(window).resize(function () {
  let windowsWidth = jQuery(window).outerWidth();
  if (windowsWidth >= 1250) {
    /**
     * REMOVE ALL CLASSES FROM OPEN MEGA MENU MOBILE to enable desktop hover menu on resize
     */
    if (jQuery("#main-menu").hasClass("invisible")) {
      jQuery("#main-menu").removeClass("invisible");
    }

    if (jQuery("#mainmenutoggler").hasClass("show")) {
      jQuery("#mainmenutoggler").removeClass("show");
    }

    if (jQuery(".main-header").hasClass("sticky")) {
      jQuery(".sticky").removeClass("sticky");
    }
    jQuery("#main-menu .dropdown-menu.megamenu").each(function () {
      if (jQuery(this).hasClass("d-flex")) {
        jQuery(this).removeClass("d-flex");
      }
      if (jQuery(this).hasClass("visible")) {
        jQuery(this).removeClass("visible");
      }
      if (jQuery(this).hasClass("invisible")) {
        jQuery(this).removeClass("invisible");
      }
    });
  }

  /* this document */
});

jQuery(document).click(function ()
{
  let container = jQuery(".action-click-container .action-container");
  if (!container.is(event.target) && !container.has(event.target).length)
  {
    handleHasHiddenTextToggleClassClicked();
  }
});


//Career -Associate partner page HTML Elements

document.addEventListener('DOMContentLoaded', function() {
  var isExecuted = false;

  window.addEventListener('scroll', function() {
      var partnerInfoElements = document.querySelectorAll(".sy_partnerinfo");
      
      partnerInfoElements.forEach(function(element) {
          if (isScrolledIntoView(element) && !isExecuted) {
              isExecuted = true;

              document.querySelector('.sy_partnerinfo__row1').classList.add('open');
              document.querySelector('.sy_partnerinfo__row1').parentElement.classList.add('zw-border');
              setTimeout(function() {
                  toggleBounce(document.querySelector('.sy_partnerinfo__arrow1'), 3);
              }, 100);

              setTimeout(function() {
                  document.querySelector(".sy_partnerinfo__row2").classList.add("open");
                  document.querySelector('.sy_partnerinfo__row2').parentElement.classList.add('zw-border');
              }, 500);

              fadeInWithDelay('.sy_partnerinfo__arrow2', 1000);
              fadeInWithDelay('.sy_partnerinfo__arrow3', 2000);

              setTimeout(function() {
                  document.querySelector('.sy_partnerinfo__row3').classList.add('open');
                  document.querySelector('.sy_partnerinfo__row3').parentElement.classList.add('zw-border');
              }, 1500);

              setTimeout(function() {
                  document.querySelector('.sy_partnerinfo__row4').classList.add('open');
                  document.querySelector('.sy_partnerinfo__row4').parentElement.classList.add('zw-border');
              }, 2000);
          }
      });
  });

  function isScrolledIntoView(elem) {
      var docViewTop = window.scrollY;
      var docViewBottom = docViewTop + window.innerHeight;

      var elemTop = elem.getBoundingClientRect().top + docViewTop;
      var elemBottom = elemTop + elem.clientHeight;

      return (docViewBottom >= elemTop);
  }

  function toggleBounce(element, times) {
      // Simple bounce effect (you can modify this for actual bounce animation)
      for (let i = 0; i < times; i++) {
          setTimeout(function() {
              element.style.transform = 'translateY(-10px)';
              setTimeout(function() {
                  element.style.transform = 'translateY(0)';
              }, 100);
          }, i * 200);
      }
  }

  function fadeInWithDelay(selector, delay) {
      var element = document.querySelector(selector);
      setTimeout(function() {
          element.style.opacity = 0;
          element.style.display = 'block';
          var fadeEffect = setInterval(function() {
              if (!element.style.opacity) {
                  element.style.opacity = 0;
              }
              if (element.style.opacity < 1) {
                  element.style.opacity = parseFloat(element.style.opacity) + 0.1;
              } else {
                  clearInterval(fadeEffect);
              }
          }, 50);
      }, delay);
  }
});



// Hide the dropdown on scroll
window.addEventListener("scroll", function () {
  const dropdowns = document.querySelectorAll(".desktop .menu-item-has-children .dropdown-menu");

  dropdowns.forEach(function (dropdown) {
      dropdown.style.display = "none"; 
  });
});

// Show dropdown on hover
document.querySelectorAll(".desktop .menu-item-has-children").forEach(function (menuItem) {
  menuItem.addEventListener("mouseenter", function () {
      const dropdown = this.querySelector(".dropdown-menu");
      if (dropdown) {
          dropdown.style.display = "flex"; // Show the dropdown on hover
      }
  });

  menuItem.addEventListener("mouseleave", function () {
      const dropdown = this.querySelector(".dropdown-menu");
      if (dropdown) {
          dropdown.style.display = "none"; // Hide the dropdown when the mouse leaves
      }
  });
});

// CF7 GTM
document.addEventListener
('wpcf7submit', function(event)
{
  const formElement = event.target;
  const gtmID = formElement.querySelector('input[name="gtm-id"]')?.value;
  const gtmLabel = formElement.querySelector('input[name="gtm-label"]')?.value;

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push
  ({
    event: 'wpcf7mailsent',
    gtmID,
    gtmLabel
  });
// //test
//   console.log
//   ("GTM:",
//     {
//       event: 'cf7_form_submit',
//       formID: gtmID, gtmLabel
//     }
//   );
}, false
);




